module.exports = __webpack_public_path__ + "static/media/sort-arrow-down.4fa42932.svg";